import React, { useState } from 'react';
import { Fade, Zoom } from 'react-reveal';
import styled from 'styled-components';

import { Flex, Text } from '../../../components';

const Container = styled(Flex)`
  width: 100%;
  max-width: 900px;
  padding: 25px;
  border-bottom: 1px solid #414568;
`;

const Dot = styled.div`
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(180deg, #ff73de, #f73acb);
`;

const Toggle = styled.svg`
  width: 23px;
  height: 25px;
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  ${props => props.open && `&:first-of-type { transform: rotate(180deg) }`}
  path {
    stroke: #00c1ff;
    stroke-width: 3px;
    transition: 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    ${props => props.open && `&:first-of-type { transform: rotateX(90deg) }`}
  }
`;

const questions = [
  {
    question: 'How to purchase tricklebot?',
    answer: 'You can purchase trickle through random restocks, groupbuys and third party marketplaces.',
  },
  {
    question: 'Where can I receive support?',
    answer: 'Members of trickle can recieve support through our discord server, which has many support members ready to answer all questions!',
  },
  {
    question: 'How much is a license and renewal fee?',
    answer: `The price of trickle is $499 and then it is $50/month.`,
  },
  {
    question: 'What operating system do we support?',
    answer: 'We currently support Windows only.',
  },
  {
    question: 'What sites are supported?',
    answer: 'We currently support Walmart, Shopify, Yeezysupply, and more coming soon!',
  },
];

const Question = ({ question, answer }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Container>
      <Dot />
      <Flex w="40px" />
      <Flex dir="column" w="calc(100% - 80px)">
        <Flex h="40px" dir="row" w="100%" align="center" onClick={() => setOpen(!isOpen)}>
          <Text.Heading size="21">{question}</Text.Heading>
          <Flex fg="1" width="20px" />
          <Toggle open={isOpen} viewBox="0 0 23 25" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 2V23" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 12.5H23" strokeLinecap="round" strokeLinejoin="round" />
          </Toggle>
        </Flex>
        <Fade up collapse when={isOpen}>
          <Flex h="25px" />{' '}
          <Text.Body size="18" color="#7178B2">
            {answer}
          </Text.Body>
        </Fade>
      </Flex>
    </Container>
  );
};

const FAQ = () => (
  <Flex id="faq" dir="column" w="100%" align="center">
    <Zoom>
      <Text.Heading style={{ maxWidth: '90%' }} center size="36">
        Frequently Asked <span style={{ color: '#FF8C3B' }}>Questions</span>
      </Text.Heading>
    </Zoom>
    <Flex h="100px" />
    {questions.map(question => (
      <Fade up>
        <Question key={question} {...question} />
      </Fade>
    ))}
  </Flex>
);
export default FAQ;
